import { BASE_URL_API, BASE_URL_API_USER } from '@constants/base';
import { get, post } from '@utils/ajax';

/**
 * Shipping Request Service
 * Handles all shipping request related API calls
 */
const customerManagerList = (() => {
    // Get shipping request list
    const getCustomerManagerList = async params => {
        try {
            const response = await get(`${BASE_URL_API}/main/customerManagement/list_api.php`, params, {
                showError: true
            });
            return response;
        } catch (error) {
            return error;
        }
    };

    // Insert customer manager
    const insertCustomerManager = async payload => {
        try {
            const response = await post(`${BASE_URL_API}/main/customerManagement/insert_api.php`, payload, {
                showError: true
            });
            return response;
        } catch (error) {
            return error;
        }
    };

    // Set company (for switching to user view)
    const setCompany = async companyId => {
        try {
            // API accepts GET method with comp_cd parameter
            const response = await get(`${BASE_URL_API}/main/customerManagement/set_company.php`, { comp_cd: companyId }, {
                showError: true
            });
            return response;
        } catch (error) {
            return error;
        }
    };

    // Update customer company (admin only)
    // Note: This calls user API endpoint but requires admin authentication
    const updateCustomerCompany = async payload => {
        try {
            const response = await post(`${BASE_URL_API_USER}/main/company/update.php`, payload, {
                showError: true
            });
            return response;
        } catch (error) {
            return error;
        }
    };

    return {
        getCustomerManagerList,
        insertCustomerManager,
        setCompany,
        updateCustomerCompany
    };
})();

export default customerManagerList;
